<!-- Navigation -->
<calsoft-vertical-navigation class="bg-cool-gray-900 theme-dark"
                         *ngIf="isScreenSmall"
                         [appearance]="'classic'"
                         [mode]="'over'"
                         [name]="'mainNavigation'"
                         [navigation]="data.navigation.default[0]"
                         [opened]="false">

    <div calsoftVerticalNavigationContentHeader>
        <div class="logo">
                 <img [src]="path" onerror="this.src='assets/images/logo/logo.png';" alt="">
        </div>
    </div>

</calsoft-vertical-navigation>

<!-- Wrapper -->
<div class="wrapper">

    <!-- Header -->
    <div class="header">

        <div class="container">

            <!-- Logo -->
            <div class="logo"
                 *ngIf="!isScreenSmall">

                     <img [src]="path" onerror="this.src='assets/images/logo/logo.png';" alt="">
               
            </div>

            <!-- Horizontal navigation -->
            <calsoft-horizontal-navigation *ngIf="!isScreenSmall"
                                       [name]="'mainNavigation'"
                                       [navigation]="data.navigation.horizontal[0]"></calsoft-horizontal-navigation>

            <!-- Navigation toggle button -->
            <button [attr.guide]="'centered-btn-1' + '__' + sanitizeUrl(url)" class="navigation-toggle-button"
                    *ngIf="isScreenSmall"
                    mat-icon-button
                    (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'menu'"></mat-icon>
            </button>

            <!-- Spacer -->
            <div class="spacer"></div>

           
           

         
         

           
          



          
            <user></user>

        </div>

    </div>

    <!-- Content -->
    <div class="content">

        <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
             it won't register the changes on the layout and won't update the view. -->
        <router-outlet *ngIf="true"></router-outlet>

    </div>

    <!-- Footer -->
    <div class="footer">
        <div class="container">
            Calsoft &copy; {{currentYear}}
        </div>
    </div>

</div>
